module.exports = __webpack_public_path__ + "static/img/cover.c5c23ec2.jpeg";